import { Outlet } from "@tanstack/react-router";
import type { ComponentProps } from "react";
import { FindPage } from "../find/FindPage";
import {
    type FindRouteMatch,
    homeRouteId,
    useRetainedFindMatch,
} from "./use-retained-find-match";

function findPageProps(
    match: FindRouteMatch,
): Omit<ComponentProps<typeof FindPage>, "visible"> {
    return {
        routePath: match.routeId === homeRouteId ? "/" : "/find",
        estimatedLocation: match.context.estimatedLocation,
        searchCorrelation: match.context.searchCorrelation,
        searchParams: match.search,
        searchPromise: match.loaderData?.searchPromise,
        feedReadyPromise: match.loaderData?.feedReadyPromise,
    };
}

export function FindRetentionLayout() {
    const { match, active } = useRetainedFindMatch();
    const hidden = !active;

    return (
        <>
            {match ? (
                <div
                    hidden={hidden || undefined}
                    inert={hidden ? true : undefined}
                    aria-hidden={hidden || undefined}
                    className={hidden ? undefined : "contents"}
                >
                    <FindPage {...findPageProps(match)} visible={active} />
                </div>
            ) : null}
            <Outlet />
        </>
    );
}

export const browseDogsFindRetentionRoute = {
    component: FindRetentionLayout,
};
